// Owner: home-inbox. System notifications (the meeting recorder's, for one) carry their title and text as
// message keys next to the stored text (`notification.message`). The inbox words them in the language of the
// screen, so the bell, the list and the detail never mix the member's saved language with the one in use; the
// stored text is the fallback for keys this build does not know.
import type { InboxItem, InboxPage } from '@dataroom/core/inbox';
import type { NotificationDTO, NotificationMessageRef } from '@dataroom/core/workflows';
import { hasMessage, tDynamic } from '../../lib/i18n';

const word = (ref: NotificationMessageRef | null | undefined): string | null =>
  ref && hasMessage(ref.key) ? tDynamic(ref.key, ref.params) : null;

export function localizeNotification<N extends NotificationDTO>(n: N): N {
  if (!n.message) return n;
  const title = word(n.message.title);
  const body = word(n.message.body);
  return title || body ? { ...n, title: title ?? n.title, body: body ?? n.body } : n;
}

export function localizeInboxItem(item: InboxItem): InboxItem {
  if (!item.notification?.message) return item;
  const notification = localizeNotification(item.notification);
  return { ...item, title: notification.title, notification };
}

export const localizeInboxPage = (page: InboxPage): InboxPage => ({
  ...page,
  items: page.items.map(localizeInboxItem),
});
